module.exports = __webpack_public_path__ + "assets/img/logo-mynavi.ca140b8d.gif";